import React from 'react'
import { Box, Divider, Link, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useExternalApp } from '../../../../../../../hooks'
import { formatDate } from './plan-details/util'

const useStyles = makeStyles(
  ({ spacing, palette, typography, breakpoints }) => ({
    root: {
      [breakpoints.up('md')]: {
        maxWidth: 375
      }
    },
    title: {
      ...typography.heading.h5,
      fontWeight: typography.fontWeightMedium,
      color: palette.grey.shade[90],
      marginBottom: spacing(3.5)
    },
    subtitle: {
      ...typography.body.s,
      fontWeight: typography.fontWeightBold,
      color: palette.grey.shade[100],
      marginBottom: spacing(1)
    },
    body: {
      ...typography.body.s,
      color: palette.grey.shade[100],
      marginBottom: spacing(1.2)
    },
    divider: {
      backgroundColor: palette.common.black,
      marginBottom: spacing(1.2),
      marginTop: spacing(2)
    }
  })
)

const SuspendCompletePanel = ({
  suspension,
  'data-test': testAttr = 'retention-complete-suspend-panel'
}) => {
  const classes = useStyles()
  const { getMtUrl } = useExternalApp()
  return (
    <Box data-test={testAttr} className={classes.root}>
      <Typography className={classes.title}>Details</Typography>
      <Typography className={classes.subtitle}>
        Your suspension will begin on your next billing date, but you will not be charged
      </Typography>
      <Typography className={classes.body}>
        You can access Mind Tools features until{' '}
        <strong>{formatDate(suspension.start)}</strong>
      </Typography>
      <Divider orientation='horizontal' className={classes.divider} />
      <Typography className={classes.subtitle}>
        No new charges for three months
      </Typography>
      <Typography className={classes.body}>
        Your account will resume automatically at the end of your suspension.
      </Typography>
      <Typography className={classes.subtitle}>
        Keep using Mind Tools as a free user
      </Typography>
      <Typography className={classes.body}>
        You still have access to two free Mind Tools resources per month.{' '}
        <Link
          href={getMtUrl('about')}
          color='primary'
          underline='always'
          data-test={`${testAttr}-explore-link`}
        >
          Keep exploring.
        </Link>
      </Typography>
    </Box>
  )
}

export default SuspendCompletePanel
